import { render, staticRenderFns } from "./business-teams-page.vue?vue&type=template&id=34e0ec93&"
import script from "./business-teams-page.vue?vue&type=script&lang=js&"
export * from "./business-teams-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports